/* ==========================================================================
 *  Function: Counter
 * ======================================================================= */

function fn_components_counter(){
	if ($( '.js-counter' ).length){
		$( '.js-active-class-trigger.status-bar-content' ).on( 'click' , function () {
			var inst = $(this);
			var activeTab = inst.find( '.status-bar-content .js-tabs-content-item.is-active' );
			
			counter(activeTab);
		});

		$( '.status-bar-content .js-tabs-list-item' ).click(function() {
			var inst = $(this);
			var activeTab = inst.find( '.status-bar-content .js-tabs-content-item.is-active' );
			counter(activeTab);
		});
	}
}

function counter(activeTab){
	// console.log("asdpred");
	
	// if (!activeTab.hasClass( 'is-animated' )){
	
	$( '.js-counter' ).text( '0' );
	
	$( '.js-counter' ).each(function () {
		$(this).prop('Counter',0).delay(100).animate({
			Counter: $(this).data('count')
		}, {
			duration: 400,
			easing: 'linear',
			step: function (now) {
				$(this).text(Math.ceil(now));
			}
		});
	});
		// activeTab.addClass( 'is-animated' );
	// }
}